import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Toolbar from "@material-ui/core/Toolbar";
import React, { Component } from "react";
import { Link } from "react-router-component";
import { NavContext } from "../App";
import * as Util from "../util/util";

const SideBarButton = ({ children, link, icon }) => (
    <Link className="menuItem" style={{ textDecoration: "none" }} href={link}>
        <div style={{ borderBottom: "1px solid black", padding: 16, display: "flex", alignItems: "center" }}>
            <i className="material-icons">{icon}</i>
            <p className="wide" style={{ marginLeft: 16 }}>{children}</p>
        </div>
    </Link>
);

class ActionBar extends Component {

    static contextType = NavContext;

    constructor() {
        super();
        this.state = { menuOpen: false };
    }

    render() {
        return (
            <div>
                <AppBar position="static">
                    <Toolbar style={{ color: "white", background: window.primary }}>
                        {this.backButtons()}
                        <h2 style={{ marginLeft: 16 }}>{this.props.title}</h2>
                        <div style={{ flex: "1" }} />

                        {this.rhsButtons()}
                    </Toolbar>
                </AppBar>

                {this.state.menuOpen && (
                    <div>
                        <div
                            onClick={() => this.setState({ menuOpen: false })}
                            style={{
                                position: "fixed",
                                top: 64,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: "transparent",
                                zIndex: 999, // just behind the sidebar
                            }}
                        />
                        
                        <div style={{
                            position: "fixed",
                            background: "#EEE",
                            left: 0,
                            top: 64,
                            bottom: 0,
                            width: 400,
                            zIndex: 1000,
                            boxShadow: "0px 8px 16px 0px rgba(0, 0, 0, 0.2)",
                            height: "calc(100vh - 64px)",
                            overflowY: "auto"
                        }}>
                            {Util.isAdmin() && <SideBarButton icon="supervised_user_circle" link="/users">Manage Users</SideBarButton>}
                            <SideBarButton icon="show_chart" link="/log">Usage and Logs</SideBarButton>
                            <SideBarButton icon="search" link="/images">Image Search</SideBarButton>
                            <SideBarButton icon="photo_library" link="/matrices">Matrix Views</SideBarButton>
                            <SideBarButton icon="account_circle" link="/account">Account Info</SideBarButton>
                            <SideBarButton icon="camera_alt" link="/imageCounts">Camera Stats</SideBarButton>
                            <SideBarButton icon="signal_cellular_alt" link="/gsmNetwork">GSM / IP Networks</SideBarButton>
                            {/* <SideBarButton icon="layers" link="/gis">GIS Management</SideBarButton>
                    <SideBarButton icon="warning" link="/faults">Fault Tracking</SideBarButton> */}
                            {Util.isAdmin() && <SideBarButton icon="notifications_active" link="/broadcast">Broadcast</SideBarButton>}
                            {/* {Util.isAdmin() && <SideBarButton icon="drive_eta" link="/vehicles">Vehicles</SideBarButton>}
                    {Util.isAdmin() && <SideBarButton icon="assistant_photo" link="/assets">Assets</SideBarButton>}
                    {Util.isAdmin() && <SideBarButton icon="commute" link="/journeys">Journeys</SideBarButton>} */}
                            {/* {Util.isAdmin() && <SideBarButton icon="settings" link="/settings">Settings</SideBarButton>} */}
                            <SideBarButton icon="info" link="/about">About</SideBarButton>
                        </div>
                    </div>
                )}
            </div>
        );
    }


    backButtons = () => {
        if (this.props.hideBack || this.props.hideAll) {
            if (this.props.showMenu) {
                return <i onClick={() => this.setState({ menuOpen: !this.state.menuOpen })} style={{ fontSize: 32 }}
                    className="material-icons hoverable noselect">menu</i>;
            }
            return;
        }
        return [<Button onClick={this.goBack} style={{ color: "white" }}>
            <i style={{ fontSize: 48 }} className="material-icons">arrow_back</i>
        </Button>,
        <Button component={Link} href={this.homeUrl()} style={{ color: "white" }}>
            <i style={{ fontSize: 48 }} className="material-icons">home</i>
        </Button>
        ];
    };

    rhsButtons = () => {
        if (this.props.hideAll) {
            return;
        }
        if (Util.isCommunity()) {
            return [
                <p>{Util.getAppName()}</p>,
                <button className="w3-button w3-white" onClick={Util.unpair}>Unpair</button>
            ];
        }
        return [
            <p>{Util.getUsername()}</p>,
            <i className="material-icons hoverable" title="Logout" style={{ fontSize: 36, marginLeft: 16, marginRight: 16 }}
                onClick={Util.logout}>logout</i>,
            <div className="dropdown" style={{ marginRight: 16 }}>
                <NavContext.Consumer>
                    {value =>
                        <button onMouseEnter={e => value.toggleMenu(true)} onMouseLeave={e => value.toggleMenu(false)} className="dropbtn w3-button w3-white">Jump To</button>
                    }
                </NavContext.Consumer>
            </div>
        ];
    };

    goBack = () => {
        if (document.referrer.indexOf("vision-link.co.uk") == -1 && document.referrer.indexOf("localhost") == -1) {
            console.log("going home " + document.referrer);
            window.location.replace(this.homeUrl());
        } else {
            console.log("going back");
            window.history.back();
        }
    };

    homeUrl = () => {
        return (Util.isSubAccount() || Util.isCommunity()) ? "/matrix/0" : "/";
    };

}


export default ActionBar;
